<template lang="pug">
  #answered-questions
    WtTile
    .columns.is-centered.is-mobile(v-if="!memberLoaded")
      ContentLoader(:width="300" :height="100")
        rect(x="0", y="0", rx="4", ry="4", width="70%", height="40")
        rect(x="0", y="45", rx="4", ry="4", width="70%", height="40")
        rect(x="0", y="90", rx="4", ry="4", width="70%", height="40")
    .columns.is-centered.is-mobile(v-else-if="!noQuestions")
      .column.box.confirmation-message.animated.fadeIn
        .column.p-6.is-half-desktop
          div.mb-6(v-for="q in member.answeredQuestions" :key="q.id" class="my-5")
            WtLabel.is-size-5(
              slot="label"
              :text="q.question"
              :required="q.required"
            )
            .is-size-7.has-text-grey.question-description(v-html="q.description")
            QuestionAnswers(:question="q" :previewAnswer="answerPreview(q)")
            .is-size-7.has-text-grey.question-description Answered: {{date(q.memberAnswer.date, 'DATE_FORMAT_FULL_MONTH').formatted}}

    .columns.is-centered.is-mobile(v-else)
      WtTitle There are no questions you answered yet!
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import QuestionAnswers from "@@/ProgramQuestions/QuestionAnswers";
import { ContentLoader } from "vue-content-loader";
import WtLabel from "@@/WtLabel/WtLabel";
import WtTitle from "@@/WtTitle/WtTitle";
import { mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";

export default {
  name: "MemberQuestionsAnswered",

  components: { WtTile, QuestionAnswers, ContentLoader, WtLabel, WtTitle },

  mixins: [dateUtilityMixin],

  props: {},

  computed: {
    ...mapGetters("members", ["member", "memberLoaded"]),

    noQuestions() {
      return !(
        this.member.answeredQuestions && this.member.answeredQuestions.length
      );
    }
  },
  methods: {
    answerPreview(responseData) {
      if (responseData.type === "checkbox") {
        return this._.get(responseData, "memberAnswer.response", null).split(
          ","
        );
      } else {
        return this._.get(responseData, "memberAnswer.response", null);
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.question-description /deep/ a
  color: $primary
</style>
